import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * La clase tableProductsThirdByBetShopView extiende JetView para crear una vista de tabla para productos de terceros en la tienda de apuestas.
 * @class
 */
export default class tableProductsThirdByBetShopView extends JetView {
    /**
     * Configures the table view for displaying third-party products by bet shop.
     * @returns {object} The configuration object for the table view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Retrieves the localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Configures the date format

        // Sample data for the table
        const data = [
            {
                BetShop: 'Mundo Slot',
                Product: 'Inbet',
                StateSwitch: 1,
            },
            {
                BetShop: 'Mundo Slot',
                Product: 'Worldmatch',
                StateSwitch: 1,
            },
            {
                BetShop: 'Mundo Bet',
                Product: 'Worldmatch',
                StateSwitch: 1,
            },
            {
                BetShop: 'Punto V 3',
                Product: 'Ezugui',
                StateSwitch: 1,
            },
        ];

        // Sample accounts for the combo box
        var accounts = [{ value: 'Cuenta 1' }, { value: 'Cuenta 1' }, { value: 'Cuenta 1' }];

        return {
            view: 'treetable', // Specifies the view type as a tree table
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            id: 'ProductList', // Unique identifier for the table
            scrollY: screen.width < 820 ? false : true, // Enables vertical scrolling based on screen width
            height: screen.width < 820 ? 490 : 0, // Sets the height based on screen width
            bready: function() {
                this.openAll(); // Opens all tree table nodes
            },
            columns: [
                {
                    id: 'Id', // Column ID
                    header: 'Id', // Column header
                    width: 250, // Column width
                    hidden: true, // Hides the column
                },
                {
                    id: 'BetShopId', // Column ID
                    header: _('BetShopId'), // Localized column header
                    width: 250, // Column width
                    hidden: true, // Hides the column
                },
                {
                    id: 'ProductId', // Column ID
                    header: _('ProductId'), // Localized column header
                    width: 250, // Column width
                    hidden: true, // Hides the column
                },
                {
                    id: 'Product', // Column ID
                    header: _('Producto'), // Localized column header
                    width: 250, // Column width
                    template: function(obj, common) {
                        // Template for rendering the column content
                        if (obj.$group) return common.treetable(obj, common) + obj.value;
                        return obj.Product;
                    },
                },
                {
                    id: 'StateSwitch', // Column ID
                    width: 150, // Column width
                    template: function(obj) {
                        // Template for rendering the state switch
                        if (obj.$level == 1) {
                            return '';
                        } else {
                            if (obj.StateSwitch) {
                                return (
                                    `<span class="webix_icon switcher fa-toggle-${obj.StateSwitch ? 'on' : 'off'}" style="
        position: relative;
        display: inline-table;
        height: 100%;
    ">
    <div class="webix_switch_box  webix_switch_on" style="width:91px"><span class="webix_switch_text">` +
                                    _('Activo') +
                                    `</span><button class="webix_switch_handle" aria-label="" role="checkbox" tabindex="0" aria-checked="true" "="" style="left: 69px;"><input id="x1560198470061" class="webix_switch_toggle" type="checkbox"></button></div>
    </span>`
                                );

                                return (
                                    '<div class=""  style=""><div class="webix_switch_box  webix_switch_on" style="width:91px;"><span class="webix_switch_text" style="\n' +
                                    '    height: 20px;\n' +
                                    '    padding: 0px;\n' +
                                    '    vertical-align: top;\n' +
                                    '">' +
                                    _('Activo') +
                                    '</span><button class="webix_switch_handle" aria-label="" switcher role="checkbox" tabindex="0" aria-checked="true" "="" style="left: 69px;"><input id="x1560198470061" class="webix_switch_toggle" type="checkbox"></button></div></div>'
                                );
                            } else {
                                return (
                                    `<span class="webix_icon switcher fa-toggle-${obj.StateSwitch ? 'on' : 'off'}" style="
        position: relative;
        display: inline-table;
        height: 100%;
    ">
    <div class="webix_switch_box  webix_switch_off" style="width:91px"><span class="webix_switch_text">` +
                                    _('Inactivo') +
                                    `</span><button class="webix_switch_handle" aria-label="" role="checkbox" tabindex="0" aria-checked="true" "="" style="left: 0px;"><input id="x1560198470061" class="webix_switch_toggle" type="checkbox"></button></div>
    </span>`
                                );
                                return (
                                    '<div class=""  style=""><div class="webix_switch_box  webix_switch_off" switcher style="width:91px;"><span class="webix_switch_text" style="\n' +
                                    '    height: 20px;\n' +
                                    '    padding: 0px;\n' +
                                    '    vertical-align: top;\n' +
                                    '">' +
                                    _('Inactivo') +
                                    '</span><button class="webix_switch_handle" aria-label="" switcher role="checkbox" tabindex="0" aria-checked="true" "="" style="left: 0px;"><input id="x1560198470061" class="webix_switch_toggle" type="checkbox"></button></div></div>'
                                );
                            }
                        }
                    },
                },
                {
                    id: 'Account', // Column ID
                    container: 'combo', // Specifies the container type
                    editor: 'combo', // Enables combo box editing
                    header: _('Cuenta Contable'), // Localized column header
                    width: 180, // Column width
                    suggest: {
                        body: {
                            yCount: 5, // Number of visible options
                            data: ['Cuenta 1', 'Cuenta 2', 'Cuenta 3', 'Cuenta 4', 'Cuenta 5', 'Cuenta 6'], // Combo box options
                        },
                    },
                },
            ],
            on: {
                /**
                 * Event triggered after editing stops.
                 * Sends the updated data to the server.
                 * @param {object} euv - Event object.
                 * @param {object} id - Edited row ID.
                 * @param {object} grid - The grid object.
                 */
                onAfterEditStop: function(euv, id, grid) {
                    var filter = '';
                    grid = $$('ProductList');
                    var url = grid.data.url;
                    var values = this.getItem(id.row);

                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(
                            devConfig.geturlApi() + 'Reference/SaveProductsThirdByBetShop',
                            '[{"Product":"' +
                            values.Product +
                            '","switchEstado":"' +
                            values.switchEstado +
                            '","Accounts":"' +
                            values.Accounts +
                            '"}]',
                            {
                                error: function(text, data, XmlHttpRequest) {
                                    webix.message('Error! ');
                                },
                                success: function(text, data, XmlHttpRequest) {
                                    var json = JSON.parse(text);

                                    if (json.HasError) {
                                        webix.message({
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Ocurrio un error, comuniquese con soporte'),
                                        });
                                    } else {
                                        webix.message(_('Agregada'));
                                    }
                                },
                            },
                        );
                },
                /**
                 * Event triggered before data is loaded.
                 * Displays a loading overlay.
                 */
                onBeforeLoad: function() {
                    this.showOverlay(
                        '<div id=\'contenedor\'; class=\'container-preload\'><div style=\'position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;\' class=\'progress\'><div class=\'icon-preload girando\'></div><div class=\'load-text\'>Loading... </div></div></div>',
                    );
                },
                /**
                 * Event triggered after data is loaded.
                 * Hides the loading overlay.
                 */
                onAfterLoad: function() {
                    this.hideOverlay();
                },
            },

            onClick: {
                /**
                 * Event handler for the state switch toggle.
                 * Updates the state of the product and sends the data to the server.
                 * @param {object} e - Event object.
                 * @param {object} id - Row ID.
                 */
                switcher: function(e, id) {
                    var obj = this.getItem(id);
                    this.updateItem(id, { StateSwitch: !obj.StateSwitch });

                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(
                            devConfig.geturlApi() + 'Accounting/SaveProductThirdByBetshop',
                            {
                                Id: obj.Id,
                                State: obj.StateSwitch,
                                BetShopId: obj.BetShopId,
                                ProductId: obj.ProductId,
                            },
                            {
                                error: function(text, data, XmlHttpRequest) {
                                    webix.message(_('Error'));
                                },
                                success: function(text, data, XmlHttpRequest) {
                                    var json = JSON.parse(text);

                                    if (json.HasError) {
                                        webix.message({
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Ocurrio un error, comuniquese con soporte'),
                                        });
                                    } else {
                                        item.IsRegisterActivate = 'A';
                                        item.Action = 'A';
                                        webix.message(_('Guardado'));
                                    }
                                },
                            },
                        );
                },
            },

            editable: true, // Enables editing
            tooltip: true, // Enables tooltips
            math: true, // Enables math operations
            loadahead: devConfig.getDefaultDataFetch(), // Preloads data
            pager: 'pagerA', // Specifies the pager ID
            url: devConfig.geturlApi() + 'Accounting/GetProductsByBetShop', // Data URL
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {object} grid - The grid object to be initialized.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Retrieves the localization service
        grid = $$('ProductList'); // Gets the grid instance by its ID
        var url = grid.data.url; // Retrieves the data URL for the grid
        var filter = ''; // Initializes the filter string
        var datePopup2 = []; // Array to store account data

        // Fetches account data for the dropdown
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Sets the content type for the request
            })
            .post(devConfig.geturlApi() + 'Accounting/GetAccountSelect', '', {
                error: function(text, data, XmlHttpRequest) {
                    // Displays an error message if the request fails
                    webix.message(_('Error! '));
                },
                success: function(text, data, XmlHttpRequest) {
                    // Parses the response and stores the data in datePopup2
                    var resp = JSON.parse(text);
                    datePopup2 = resp.Data;
                },
            });

        // Groups the grid data by 'BetShop' after it is loaded
        grid.attachEvent('onAfterLoad', function() {
            $$('ProductList').data.group({
                by: 'BetShop', // Groups data by the 'BetShop' field
                map: {
                    BetShop: ['BetShop'], // Maps the 'BetShop' field
                    StateSwitch: ['StateSwitch'], // Maps the 'StateSwitch' field
                },
            });
        });

        // Listens for the 'productsThirdByBetShop:filter' event to apply filters
        this.on(this.app, 'productsThirdByBetShop:filter', (filterData) => {
            var object = Object.entries(filterData); // Converts the filter data into an array of key-value pairs
            var string1 = ''; // Initializes the filter string

            // Iterates through the filter data to construct the filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handles non-object filter values
                    if (object[i][0] == 'Datepicker') {
                        // Handles date range filters
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handles object filter values
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Constructs the 'dateFrom' filter
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Constructs the 'dateTo' filter
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            // Clears the grid and reloads it with the new filter
            grid.clearAll();
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Updates the filter string
        });
    }
}

// FILE DOCUMENTED
